export default {
    limitOrders: [],
    extraMeals: [],
};
